import commonStyle from "../style/commonStyle.module.css";

export default function ScreenTitle({ title }) {
  return (
    <div className="mt-4">
      <h1>{title}</h1>
    </div>
  );
}
